import { dayjs } from "utilz";

const CLOSED_STATUS = "da5be1f9-db9d-4c64-8e43-51b458746773";
const NEW_STATUS = "9dd09ea5-e30e-494a-9120-583caff52a3a";

const parseSlaTime = (
  value: unknown,
): [number, dayjs.ManipulateType] | null => {
  const parts = (value as string | undefined)?.split(" ");
  if (!parts || parts.length < 2) return null;
  return [Number(parts[0]), parts[1] as dayjs.ManipulateType];
};

export const calculateSlaStatus = ({
  slaRules,
  priority,
  isSlaExpired,
  status,
  createdAt,
}: {
  slaRules: Record<string, unknown>[];
  priority: string;
  isSlaExpired: boolean;
  status: string;
  createdAt: string;
}) => {
  let slaStatus = "On track";

  for (const rule of slaRules ?? []) {
    if (rule?.sla_priority !== priority) continue;

    const firstResponse = parseSlaTime(rule?.sla_first_response);
    const resolutionTime = parseSlaTime(rule?.sla_resolution_time);
    const warningTime = parseSlaTime(rule?.sla_warning_time);
    if (!firstResponse || !resolutionTime) continue;

    //1.status is CLOSED_STATUS and resolutionTime before resolutionTime -- met
    //2.status is CLOSED_STATUS and resolutionTime after resolutionTime -- met
    //3. not closed CLOSED_STATUS and resolutionTime before resolutionTime -- on track
    //4. not closed CLOSED_STATUS and resolutionTime after resolutionTime -- breached

    // if (isSlaExpired) {
    //   slaStatus = "Expired";
    //   break;
    // }

    if (status === CLOSED_STATUS) {
      slaStatus = "met";
      break;
    }

    const created = dayjs(createdAt).utc();
    const now = dayjs().utc();

    // if (
    //   status !== CLOSED_STATUS &&
    //   now.isAfter(created.add(...resolutionTime))
    // ) {
    //   slaStatus = "Expired";
    //   break;
    // }
    // if (status === NEW_STATUS && now.isAfter(created.add(...firstResponse))) {
    //   slaStatus = "Expired";
    //   break;
    // }
    // if (
    //   warningTime &&
    //   status !== NEW_STATUS &&
    //   now.isAfter(created.add(...warningTime))
    // ) {
    //   slaStatus = "Warning";
    // }

    if (now.isAfter(created.add(...resolutionTime))) {
      slaStatus = "breached";
      break;
    }
    if (status === NEW_STATUS && now.isAfter(created.add(...firstResponse))) {
      slaStatus = "breached";
      break;
    }
    if (
      warningTime &&
      status !== NEW_STATUS &&
      now.isAfter(created.add(...warningTime))
    ) {
      slaStatus = "breached";

    }
  }
      console.log("🚀 ~ calculateSlaStatus ~ slaStatus:", slaStatus)
  return slaStatus;
};
